import * as Yup from 'yup';

import StringUtils from '../../util/string';

export const uuidSchema = (fieldName: string = 'id'): Yup.StringSchema => {
  return Yup.string()
    .test('isUUIDv4', 'uuid/v4 expected but got: `${value}`', value => StringUtils.isUUIDv4(value))
    .required(`${fieldName} is required`);
};

export const uuidIdSchema = uuidSchema();
export const userIdSchema = uuidSchema('userId');
